import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-tmams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-tmams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsTmamsConstants } from "./create-application-details-tmams.constants";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDetailsTmamsComponent = class CreateApplicationDetailsTmamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsTmamsConstants.VALIDATION_MESSAGES;
    descriptionFormControlName = CreateApplicationDetailsTmamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = CreateApplicationDetailsTmamsConstants.TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    descriptionLabel = CreateApplicationDetailsTmamsConstants.DESCRIPTION_LABEL;
    typeLabel = CreateApplicationDetailsTmamsConstants.TYPE_LABEL;
    applicationTypes = [];
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("applicationTypes")) {
                this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and (name eq 'ApplicationType')`,
        };
        this.createApplicationService
            .getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsTmamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "ApplicationType") {
                    applicationTypes.push(JSON.parse(item.content));
                }
            });
        }
        applicationTypes.sort((a, b) => a.value.localeCompare(b.value));
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.applicationTypes = applicationTypes;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsTmamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-tmams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsTmamsComponent);
export { CreateApplicationDetailsTmamsComponent };
